import Layout from '@/views/layout'
export default {
  path: '/vehicleAlarm',
  name: 'alarmRecord',
  menuName: '车辆报警',
  component: Layout,
  meta: { title: 'vehicleAlarm', icon: 'car-alarm', iconType: 'svg' },
  children: [
    {
      path: 'offlineAlarm',
      name: 'offlineAlarm',
      menuName: '防拆/信号丢失报警',
      component: () => import('@/views/vehicleAlarm/offlineAlarm'),
      meta: { title: 'offlineAlarm', icon: 'offlineAlarm', iconType: 'svg' }
    },
    {
      path: 'overspeedAlarm',
      name: 'overspeedAlarm',
      menuName: '超速报警',
      component: () => import('@/views/vehicleAlarm/overspeedAlarm'),
      meta: { title: 'overspeedAlarm', icon: 'overspeedAlarm', iconType: 'svg' }
    },
    {
      path: 'overspeedRule',
      name: 'overspeedRule',
      menuName: '超速报警规则设置',
      component: () => import('@/views/vehicleAlarm/overspeedRule'),
      meta: { title: 'overspeedRule', icon: 'overspeedAlarm', iconType: 'svg' }
    },
    {
      path: 'overspeedRecord',
      name: 'overspeedRecord',
      menuName: '超速报警记录',
      component: () => import('@/views/vehicleAlarm/overspeedRecord'),
      meta: { title: 'overspeedRecord', icon: 'trip', iconType: 'svg' }
    }
  ]
}